const isNumber = value => typeof value === "number" && Number.isFinite(value);

const isPremium = row => row.label.startsWith("Premium-");
const isDelivery = row => row.label.startsWith("Table Stake-") || row.label.startsWith("Watch-");

function total(rows, predicate) {
  const selected = rows.filter(predicate);
  if (selected.some(row => !isNumber(row.capturableWtp))) return null;
  return selected.reduce((sum, row) => sum + row.capturableWtp, 0);
}

const add = (first, second) => isNumber(first) && isNumber(second) ? first + second : null;

export default {
  buildSummary(rows, supplied = {}) {
    // Derive missing totals from the rows used by the chart, table, and exports.
    const premiumWtp = total(rows, isPremium);
    const tableStakeWtp = total(rows, isDelivery);
    const premium = total(rows, row => row.focus && isPremium(row));
    const tableStake = total(rows, row => row.focus && isDelivery(row));
    const summary = {
      premiumWtp,
      tableStakeWtp,
      growthTotalWtp: add(premiumWtp, tableStakeWtp),
      premium,
      tableStake,
      growthTotal: add(premium, tableStake),
      opportunity: "In-Demand & Untapped",
      strategy: "Delivery Growth",
      marketType: "—"
    };
    Object.keys(summary).forEach(field => {
      const value = supplied[field];
      if (typeof summary[field] === "string") {
        if (typeof value === "string" && value.trim()) summary[field] = value;
      } else if (isNumber(value) && !["premium", "tableStake", "growthTotal"].includes(field)) {
        summary[field] = value;
      }
    });
    const marketValue = [supplied.marketValue, ...rows.map(row => row.marketValue)]
      .find(value => typeof value === "string" && value.trim());
    if (marketValue != null) summary.marketType = marketValue;
    const averages = {};
    ["inDemand", "untapped", "tableStake", "watch"].forEach(field => {
      const values = rows.map(row => row[field]).filter(isNumber);
      averages[field] = values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : null;
    });
    return { ...supplied, ...summary, averages };
  }
};
